<template>
  <!-- Container principal da página -->
  <div class="container-fluid">
    <!-- Cabeçalho da página -->
    <header class="header">
      <div class="container">
        <!-- Logo -->
        <div class="logo">
          <img src="../assets/img/icon-gpi-nfse.svg" alt="Logo gpi e NFSE" />
        </div>
      </div>
    </header>

    <!-- GRID DA TELA INICIAL DE LOGIN -->
    <div class="grid-principal">
    
      <!-- FLEX DO BRASAO -->
      <div class="entidade">

        <!-- IMAGEM DO BRASAO CASO O CLIENTE TENHA NO S3-->
        <img class="icone-entidade" :src="this.numbers.caminhoLogo" style="width: 140px !important;" alt v-if="!manutencao && !logoLogin && this.numbers && this.numbers.caminhoLogo" />
        
        <img :src="logoLogin" alt="Base64 encoded image" class="icone-entidade" v-show="exibirLogo" style="width: 140px !important;"/>

        <!-- Nome da entidade //// AJUSTAR --> 
        <h1 class="nome-entidade" v-if="!manutencao && this.numbers && this.numbers.nomeEntidade">{{ this.numbers.nomeEntidade }}</h1>
        <!-- Nome da entidade codificada //// AJUSTAR -->
        <h1 class="nome-entidade" v-if="!manutencao && this.numbers && this.numbers.nomeCliente">{{this.numbers.nomeCliente}}</h1>
      </div>

      <!-- FLEX DO FORMULARIO DO LOGIN -->
      <div class="form-login">
        <!-- Formulário de login -->
        <form name="form" @submit.prevent="handleLogin">
          <!-- Título do formulário -->
          <div class="form-title-primary" v-if="!manutencao">
            <span class="form-title-primary">Entrar</span>
          </div>
          <!-- Banner de manutenção -->
          <div v-if="manutencao">
            <template>
              <img src="../assets/img/full-banner.png" />
            </template>
          </div>

          <!-- INPUT DO USUARIO -->
          <div v-if="!manutencao">
            <div class="input">
              <div class="input-user">
                <span class="input-text">
                  <div class="input-wrapper">
                    <!-- Input com ícone dentro -->
                    <div class="input-with-icon">
                      <!-- Input para CPF/CNPJ -->
                      <input 
                        class="p-inputtext p-component p-filled" 
                        v-if="idSimoes === '19533831040781681800D2584C905F8A'"
                        @input="removerErro()"
                        id="usuario"
                        type="text"
                        placeholder="CPF/CNPJ"
                        autocomplete="off"
                        tabindex="1"
                        v-model="login.nomeAcesso"
                      />
                      <!-- Input para usuário -->
                      <input 
                        class="p-inputtext p-component p-filled" 
                        v-else
                        @input="removerErro()"
                        id="usuario"
                        type="text"
                        placeholder="Usuário"
                        autocomplete="off"
                        tabindex="1"
                        v-model="login.nomeAcesso"
                      />
                      <!-- Ícone dentro do input -->
                      <img src="../assets/icons/icon-user.svg" alt="icon user" class="input-icon" />
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>

          <!-- MENSAGEM DE ERRO CASO USUARIO E SENHA ERRADOS -->
          <div v-if="!manutencao">
            <!-- Mensagem de sessão expirada -->
            <template v-if="this.expired">
              <div class="error-login-form" severity="warn">Sua sessão expirou efetue um novo Login!</div>
            </template>

            <!-- Mensagem de erro genérica -->
            <template v-if="this.mensagemErro">
              <div class="error-login-form" severity="error">{{ this.mensagemErro }}</div>
            </template>

            <!-- Erro de validação do nome de acesso -->
            <template v-if="validation.hasError('login.nomeAcesso')">
              <div class="error-login-form" severity="error">{{ validation.firstError("login.nomeAcesso")}}</div>
            </template>

            <!-- Erro de validação da senha -->
            <template v-else-if="validation.hasError('login.senhaAcesso')">
              <div class="error-login-form" severity="error">{{ validation.firstError("login.senhaAcesso")}}</div>
            </template>

            <!-- Erro genérico -->
            <template v-if="this.erro">
              <div class="error-login-form" severity="error">{{ this.erro}}</div>
            </template>
          </div>

          <!-- INPUT SENHA -->
          <div class="input">
            <div class="input-user">
              <span class="input-text">
                <div class="input-with-icon">
                  <!-- Campo de senha -->
                  <input 
                    @input="removerErro()" 
                    id="senha" 
                    type="password" 
                    placeholder="Senha" 
                    autocomplete="off"
                    tabindex="2" 
                    v-model="login.senhaAcesso" 
                    class="input-senha" 
                    :class="{'error': validation.hasError('login.senhaAcesso')}" 
                  />
                  <!-- Ícone de olho para visualização de senha -->
                  <img src="../assets/icons/icon-padlock.svg" alt="Mostrar senha" class="input-icon-padlock" />
                </div>
              </span>
            </div>
          </div>

          <!-- LINK ESQUECEU SUA SENHA -->
          <div class="link-esqueceu-senha" v-if="!manutencao">
            <a class="esqueceu-senha" @click="esqueceuSenha()">Esqueceu Sua Senha?</a>
          </div>

          <!-- BOTAO ENTRAR -->
          <div class="entrar" v-if="!manutencao">
            <span class="entrar-text">
              <button type="submit" class="btnEntrar">Entrar</button>
            </span>
          </div>

          <!-- BOTAO ENTRAR COM CERTIFICADO DIGITAL -->
          <div class="outros-login" v-if="!manutencao">
            <a @click="showJanelaCertificado()">Entrar com certificado digital?</a>
          </div>
        </form>
      </div>

      <!-- FLEX DAS INFORMACOES -->
      <div class="container-infos" v-if="this.numbers">
        <!-- INFORMACAO DAS NOTAS EMITIDAS -->
        <div class="infos-text">
          <div>
            <span id="text1" class="form-subtitle">{{ this.numbers.qtdeNotasEmitidasFormatado }} NFS-e Emitidas.</span>
          </div>

          <!-- INFORMACAO DOS DEVIDO AO MUNICIPIO -->
          <div class="infos-text" v-if="false">
            <span id="text1" class="form-subtitle">{{ this.formataValorReal(this.numbers.devidoMunic) }} Devido no Municipio.</span>
          </div>

          <!-- INFORMACAO DOS DEVIDO FORA DO MUNICIPIO -->
          <div class="infos-text" v-if="false">
            <span id="text1" class="form-subtitle">{{ this.formataValorReal(this.numbers.devidoForaMunic) }} Devido Fora do Municipio.</span>
          </div>
        </div>

        <!-- INFORMACAO DAS DAPS EMITIDAS -->
        <div class="infos-text">
          <span id="text1" class="form-subtitle">{{ this.numbers.qtdeDapsEmitidosFormatado }} {{ notaTomador ? 'Notas Fiscais Tomador' : 'DAPS Emitidos'}}.</span>
        </div>

        <!-- INFORMACAO DOS CREDENCIAMENTOS REALIZADOS -->
        <div class="infos-text">
          <span id="text1" class="form-subtitle">{{ this.numbers.qtdeCredenciamentosFormatado }} Credenciamentos.</span>
        </div>

        <!-- INFO DA DENUNCIA -->
        <div class="denuncia" v-if="false">
          <div class="denuncia-col">
            <img src="../assets/img/denuncia.png"/>
          </div>
          <div class="denuncia-text">
            <span class="form-subtitle">Realize uma Denúncia relacionada à Prestação de Serviços.</span>
            <div>
              <Button label="Denúncia Fiscal" class="btnDenuncia" @click="denunciaFiscal()" />
            </div>
          </div>
        </div>
      </div>

      <!-- <div  class="container-info-contato"> -->
        <div v-if="showDadosCliente" class="container-infos-contato">
          <!-- INFORMACAO DE CONTATO DO CLIENTE -->
          <div class="infos-text-contato">
            <div>
              <span id="text1" class="form-subtitle-contato">{{ this.numbers.msgContatoLogin.trim() }}</span>
            </div>
          </div>
        </div>
      <!-- </div> -->

      <!-- LINKS HORIZONTAIS -->
      <Carousel :buttons="carouselButtons" />

      <!-- AVISOS EM CARROSSEL -->
      <AvisosCarousel :buttons="AvisosCarousel" />

    </div>

    <Dialog :visible.sync="showLinkRps" :modal="true" :closable="false" v-if="this.numbers && this.numbers.linkRps">
      <!-- Contêiner principal do modal -->
      <div class="esqueceu-senha-modal">

        <!-- Cabeçalho do modal com título e botão de fechar -->
        <div class="header-container">
          <!-- Título do modal -->
          <h1 class="titulo-header">Link Envio RPS</h1>

          <!-- Botão para fechar o modal ao clicar, utilizando o ícone personalizado -->
          <button @click="showLinkRps = false" type="button" class="btn-cancelar">
            <img src="../assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
          </button>        
        </div>

        <!-- Informações de numeros da entidade -->
        <div class="senha-info">
          <label class="info-modal">{{numbers.linkRps}}</label>
        </div>

      </div>

      <!-- Botão para requisitar nova senha -->
      <div class="button-container">
        <!-- O botão é desativado quando a variável 'loading' está verdadeira -->
        <Button @click="copiarLinkRps()" label="Copiar" class="btnAvançar" :disabled="loading" />
      </div>
    </Dialog>

    <!-- LINK DO ESQUECEU A SENHA -->
    <!-- Modal para recuperação de senha, sincronizando visibilidade com 'showEsqueceu' -->
    <Dialog :visible.sync="showEsqueceu" :modal="true" :closable="false" style="backdrop-filter: blur(1px);">
      <!-- Contêiner principal do modal -->
      <div class="esqueceu-senha-modal">

        <!-- Cabeçalho do modal com título e botão de fechar -->
        <div class="header-container">
          <!-- Título do modal -->
          <h1 class="titulo-header">Esqueceu sua Senha?</h1>

          <!-- Botão para fechar o modal ao clicar, utilizando o ícone personalizado -->
          <button @click="hideNovaSenha()" type="button" class="btn-cancelar">
            <img src="../assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
          </button>        
        </div>

        <!-- Informações de numeros da entidade -->
        <div class="senha-info">
          <label class="info-modal">Informe o tipo e seu respectivo Documento para recuperação de senha:</label>
        </div>

        <!-- Seção de seleção de tipo de pessoa e entrada de documento -->
        <div class="senha-options">

            <!-- Rótulo para o campo de seleção de tipo de pessoa -->
            <label for="tipoPessoa" class="label-tipo">Tipo: </label>

            <!-- Dropdown para seleção do tipo de pessoa (Física ou Jurídica) -->
            <span class="dropdown-container">
              <Dropdown id="tipoPessoa" v-model="selectedTipoPessoa" :options="tiposPessoa" optionLabel="name"
                placeholder="Selecione um Tipo de Pessoa" />
            </span>

            <!-- Campo de entrada condicional baseado no tipo de pessoa selecionado -->
            <div class="input-container">
              <!-- Máscara de CPF quando o tipo de pessoa é 'Física' (key 'F') -->
              <template v-if="selectedTipoPessoa && selectedTipoPessoa.key === 'F'">
                <InputMask id="recuperaLogin" type="text" placeholder="CPF" autocomplete="off"
                  v-model="loginNovaSenha" mask="999.999.999-99" key="F" />
              </template>

              <!-- Máscara de CNPJ quando o tipo de pessoa é 'Jurídica' (key 'J') -->
              <template v-else>
                <InputMask id="recuperaLogin" type="text" placeholder="CNPJ" autocomplete="off"
                  v-model="loginNovaSenha" mask="99.999.999/9999-99" key="J" />
              </template>
          </div>
        </div>
      </div>

      <!-- Botão para requisitar nova senha -->
      <div class="botoes-avancar-voltar">
        <Button label="Voltar" type="submit"  class="btnVoltar" id="btnVoltar" @click="hideJanelaSenha()"  icon="pi pi-angle-left" :disabled="loading" />
        <!-- O botão é desativado quando a variável 'loading' está verdadeira -->
        <Button @click="requisitarNovaSenha()" label="Recuperar Senha" class="btnAvançar" :disabled="loading" />
      </div>
    </Dialog>

  <!-- IMPORTAR CERTIFICADO DIGITAL -->
  <!-- Modal para seleção de certificado digital, com visibilidade controlada pela variável 'showCertificado' -->
  <Dialog :visible.sync="showCertificado" :modal="true" :closable="false" style="backdrop-filter: blur(1px);">

    <!-- Contêiner principal do modal para certificado digital -->
    <div class="certificado-digital-modal">

      <!-- Cabeçalho do modal contendo o título e o botão de fechar -->
      <div class="header-container">
        
        <!-- Título do modal -->
        <h1 class="titulo-header">Certificado Digital</h1>

        <!-- Botão para fechar o modal, chamando a função 'hideJanelaCertificado' -->
        <button @click="hideJanelaCertificado()" type="button" class="btn-cancelar">
          <!-- Ícone personalizado de fechar localizado na pasta assets -->
          <img src="../assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
        </button>
      </div>
    
      <!-- Contêiner principal do diálogo que permite rolagem -->
      <div class="scrolable-dialog">
        <!-- Exibe informações de carregamento do certificado se 'showCarregarCert' for verdadeiro -->
        <div v-if="showCarregarCert" class="certificado-info">
          <!-- Texto centralizado que informa o usuário sobre o carregamento do certificado -->
          <div class="text-center">
            Aguarde, carregando informações do certificado..
          </div>
        </div>
        
        <!-- Exibe o conteúdo do certificado caso 'showCarregarCert' seja falso -->
        <div v-if="!showCarregarCert" class="certificado-info">
          
          <!-- Informação ao usuário sobre a instalação correta do certificado digital -->
          <div class="info-modal">
            Certifique-se que o seu certificado digital está corretamente instalado no navegador.
          </div>
        
          <!-- Contêiner do botão de carregar o certificado -->
          <div class="botoes-avancar-voltar">
            <Button label="Voltar" type="submit"  class="btnVoltar" id="btnVoltar" @click="hideJanelaCertificado()"  icon="pi pi-angle-left" :disabled="loading" />
            <!-- Botão que inicia a ação de carregar o certificado digital, desativado quando 'loading' está verdadeiro -->
            <Button @click="carregarCertificado()" label="Carregue o Certificado" class="btnAvançar"  :disabled="loading" />
          </div>
        </div>
      </div>
    </div>
  </Dialog>

    <!-- Modal para validação do reCAPTCHA, com visibilidade controlada pela variável 'showCaptcha' -->
    <Dialog header="Necessária Validação do reCAPTCHA" :visible.sync="showCaptcha" :modal="true" :closable="false"
      :style="{ width: '25vw' }">

      <!-- Contêiner principal do modal com rolagem -->
      <div class="container scrolable-dialog">

        <!-- Linha para posicionar o reCAPTCHA -->
        <div class="row">

          <!-- Centraliza o componente VueRecaptcha horizontalmente e verticalmente -->
          <div class="d-flex justify-content align-items-center" style="margin: 0 auto;">

            <!-- Componente VueRecaptcha que dispara o método 'handleSuccess' ao ser verificado -->
            <VueRecaptcha @verify="handleSuccess" :sitekey="siteKey" :load-recaptcha-script="true"></VueRecaptcha>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
// Importações necessárias
import Carousel from '../components/global/Carousel.vue';             // Importa o componente de carrossel global
import AvisosCarousel from '../components/global/AvisosCarousel.vue'; // Importação correta
import Login from "../models/acesso/Login";                           // Importa o modelo de login
import LoginService from "../services/acesso/login.service";          // Importa o serviço de login
import Numero from "../services/nfse/numeros";                        // Importa o serviço de manipulação de números (relacionado à NFSe)
import DnsClienteService from "../services/nfse/dns.cliente.service"; // Importa o serviço de DNS para cliente relacionado a NFSe
import SimpleVueValidation from "simple-vue-validator";               // Importa a biblioteca de validação "SimpleVueValidation"
const Validator = SimpleVueValidation.Validator;                      // Define uma constante para o validador de formulários

export default {
  name: "login",                                                      // Nome do componente atual
  components: {                                                       // Componentes utilizados dentro deste componente
    Carousel,                                                         // Componente de carrossel global
    AvisosCarousel,
  },

  data() {
    return {
      // Dados do componente
      anoAtual: null,               // Ano atual (pode ser atualizado dinamicamente)
      erro: null,                   // Armazenamento de erros
      loading: false,               // Indicador de carregamento (exemplo: durante requisições) 
      currentUser: null,            // Informações do usuário atual logado
      expired: null,                // Informação sobre a expiração da sessão ou dados
      showEsqueceu: false,          // Controle de visibilidade do modal "Esqueceu a Senha"
      login: new Login(),           // Instância do modelo de login
      loginNovaSenha: null,         // Instância do modelo de login
      manutencao: false,            // Flag para indicar se o sistema está em manutenção
      numbers: null,                // Armazena números relacionados à NFSe
      idCliente: null,              // ID do cliente
      showCertificado: false,       // Controle de visibilidade do modal de certificado digital
      showCarregarCert: false,      // Controle de visibilidade durante o carregamento do certificado
      notaTomador: false,           // Controle de visibilidade de notas para tomador
      showDenunciaFiscal: false,    // Controle de visibilidade do modal de denúncia fiscal
      loginMenssagemSimoes: null,   // Mensagem personalizada relacionada ao login de Simões
      idSimoes: null,               // ID relacionado ao cliente de Simões
      selectedTipoPessoa: null,     // Tipo de pessoa selecionada (Física, Jurídica ou Entidade)
      tiposPessoa: [                // Opções de tipos de pessoa para seleção
        { name: "Pessoa Física", key: "F" },
        { name: "Pessoa Jurídica", key: "J" },
        { name: "Entidade", key: "E" }
      ],
      apresentacao: false,            // Controle de exibição da apresentação
      linkRequestCert: '',            // Link para requisição de certificado
      siteKey: '6LfvEi4gAAAAAMbyRV0UO2i8ovyoQkNs0suhoMc5',  // Chave do reCAPTCHA utilizada na validação
      recaptchaVerified: false,       // Status de verificação do reCAPTCHA
      showCaptcha: false,             // Controle de visibilidade do modal do reCAPTCHA 
      exibirLogo: false,              // Controle para exibição do logo no login 
      logoLogin: "",                  // Caminho para o logo utilizado no login  
      carouselButtons: [],
      AvisosCarousel: [],
      showLinkRps: false,             //Controle Exibição Dialog com Link do RPS
      msgContatoLogin: null,
      showDadosCliente: false
    };
  },

  // Hook "created" (executado quando o componente é criado)
  created() {
  // Inicializa os dados da apresentação (caso exista a propriedade '$apresentacao', utiliza-a; caso contrário, define como 'false')
  this.apresentacao = (this.$apresentacao ? this.$apresentacao : false);

  // Define o tipo de pessoa selecionado como o primeiro item da lista de tipos de pessoa
  this.selectedTipoPessoa = this.tiposPessoa[0];

  /** Valida se o Captcha deve ser exibido */
  // this.viewCaptcha(); // (Comentado, pode ser ativado se necessário para validar a exibição do Captcha)
  },


  // Definição dos validadores para os campos de login e senha
  validators: {

    // Validador para o campo "login.nomeAcesso"
    "login.nomeAcesso": function (value) {
      return Validator.value(value)
        // Verifica se o campo "Login" está preenchido
        .required("Campo Login Obrigatório")
        // Verifica se o tamanho do login não ultrapassa 200 caracteres
        .maxLength(200, "Login deve ser menor ou igual a 200");
    },

    // Validador para o campo "login.senhaAcesso"
    "login.senhaAcesso": function (value) {
      return Validator.value(value)
        // Verifica se o campo "Senha" está preenchido
        .required("Campo Senha Obrigatório")
        // Verifica se o tamanho da senha não ultrapassa 50 caracteres
        .maxLength(50, "Senha deve ser menor ou igual a 50");
    },
  },

  // Hook "mounted" (executado quando o componente é montado)
  mounted() {
    this.currentIndex = 0;                                                           // Garantir que o carrossel comece do início
    var d = new Date();                                                              // Configuração inicial
    this.anoAtual = d.getFullYear();                                                 // Armazena o ano atual
    setTimeout(async () => {                                                         // Aguarda 250 milissegundos antes de executar a lógica a seguir
      if (this.$route.query.manutencao && this.$route.query.manutencao == "N") {     // Verifica se a query "manutencao" está presente e se é igual a "N"
        this.manutencao = false;                                                     // Se sim, define 'manutencao' como false
      } else {
        document.getElementById("usuario").focus();                                  // Caso contrário, foca no campo de usuário
      }

      let host = window.location.hostname;                                           // Obtém o hostname da URL atual
      this.dnsCliente = await DnsClienteService.get(host);   
      console.log("DNS CLIENTE: ",this.dnsCliente.data);                        // Busca os dados do cliente DNS usando o hostname
      this.expired = this.$route.query.expired;                                      // Armazena se a sessão expirou com base na query

      // Verifica se os dados do cliente DNS estão disponíveis
      if (
        this.dnsCliente &&
        this.dnsCliente.data &&
        this.dnsCliente.data.idCliente
      ) {
        this.idCliente = this.dnsCliente.data.idCliente;     
        this.showDenunciaFiscal = this.apresentacao;                                 // Define se a denúncia fiscal deve ser exibida

        if ("19533831040781681800D2584C905F8A" === this.idCliente) {                 // Verificações específicas para certos IDs de cliente
          this.notaTomador = true;                                                   // Exibe nota do tomador para um cliente específico
        } else if ("ce744068-cc92-479f-bf9d-d88cf4238517" === this.idCliente) {      // Exibe denúncia fiscal para outro cliente específico
          this.showDenunciaFiscal = true;
        }

        this.idSimoes = this.dnsCliente.data.idCliente;                              // Armazena o ID do cliente de Simões

        /*
        // Código comentado que altera a mensagem de login com base no ID do cliente
        if(this.dnsCliente.data.idCliente === '19533831040781681800D2584C905F8A'){
          this.loginMenssagemSimoes = "CPF/CNPJ";
        }else{
          this.loginMenssagemSimoes = "Usuário";
        }
        */
        Numero.listarNumeros(this.dnsCliente.data.idCliente).then((res) => {        // Lista números associados ao ID do cliente 
          this.numbers = res.data;                                                 // Armazena os números retornados
          this.carouselButtons = this.carregarLinks();
          this.msgContatoLogin = this.numbers.msgContatoLogin;
          if (res.data.logoLogin) {                                                 // Se a resposta contém logo, configura para exibição  
          this.exibirLogo = true; 
          this.logoLogin = "data:image/jpg;base64,".concat(                         // Se a resposta contém logo, configura para exibição  
            this.logoLogin.concat(res.data.logoLogin) 
          );  
        } 
          console.log(res.data);                                                    // Log dos dados retornados
          this.numbers.msgContatoLogin ? this.showDadosCliente = true : this.showDadosCliente = false;
        });
      }
    }, 250);                                                                        // Tempo de espera antes da execução da lógica

    
    
    
    // this.showDadosContato();
  },

  // Hook "beforeDestroy" (executado antes do componente ser destruído)
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);                        // Remove o listener do evento de redimensionamento
  },

  methods: {
    handleSuccess(response) {                                                       // Método para lidar com o sucesso da verificação do reCAPTCHA
      console.log('reCaptcha verificado: ', response);                              // Loga a resposta da verificação do reCAPTCHA

      setTimeout(() => {                                                            // Aguarda 800 milissegundos antes de executar a lógica a seguir
        this.recaptchaVerified = true;                                              // Marca o reCAPTCHA como verificado
        this.loginUser();                                                           // Chama o método para realizar o login do usuário
        this.recaptchaVerified = false;                                             // Reseta a verificação do reCAPTCHA após o login
        this.showCaptcha = false;                                                   // Esconde o modal do Captcha
      }, 800);
    },

    showJanelaCertificado() {                                                       // Método para mostrar janela de certificado
      this.showCertificado = true;                                                  // Define a variável que controla a exibição da janela de certificado como verdadeira                                             
      this.showCarregarCert = false;                                                // Esconde o indicador de carregamento do certificado
    },

    hideJanelaCertificado() {                                                       // Método para esconder a janela de certificado
      this.showCertificado = false;                                                 // Define a variável que controla a exibição da janela de certificado como falsa                                              
      this.showCarregarCert = false;                                                // Esconde o indicador de carregamento do certificado
    },

    carregarCertificado() {                                                                             // Método para carregar certificado
      this.showCarregarCert = true;                                                                     // Exibe o indicador de carregamento do certificado
      let currentUrl = window.location;                                                                 // Obtém a URL atual da janela
      let api_url = (this.$configAppData ? this.$configAppData.baseUrl : '');                           // Define a URL da API base, se disponível
      this.linkRequestCert = 'https://certificado.cloud.el.com.br/gpilogin/base64NF';                   // Define o link para requisitar o certificado
      this.linkRequestCert = this.linkRequestCert + '?urlRetorno=' + api_url + '/requestCertificado';   // Adiciona a URL de retorno à solicitação do certificado
      this.linkRequestCert = this.linkRequestCert + "&urlFront=" + currentUrl;                          // Adiciona a URL frontal à solicitação do certificado
      window.open(this.linkRequestCert, "_self", "");                                                   // Abre o link de solicitação do certificado na mesma janela
      return false;                                                                                     // Retorna falso para evitar qualquer outro comportamento padrão
    },

    removerErro() {                                                                                     // Método para remover erro
      this.erro = null;                                                                                 // Limpa a variável de erro, definindo-a como nula

    },

    handleLogin() {                                                                                     // Método para lidar com o login
      /*desabilitado (this.apresentacao) {                                                                          // Verifica se está em modo de apresentação
        this.$validate().then((success) => {                                                            // Valida os campos do formulário
          if (success) {                                                                                // Se a validação for bem-sucedida
            this.processando(true);                                                                     // Indica que o processamento está em andamento
            if (!this.recaptchaVerified) {                                                              // Verifica se o reCAPTCHA foi verificado
              this.showCaptcha = true;                                                                  // Mostra o modal do reCAPTCHA se não estiver verificado
            } else {
              this.loginUser();                                                                         // Realiza o login do usuário se o reCAPTCHA estiver verificado
            }

            this.processando(false);                                                                    // Indica que o processamento foi concluído
          }
        });
      } else {*/
        this.$validate().then((success) => {                                                             // Se não estiver em modo de apresentação, valida os campos do formulário
          if (success) {                                                                                 // Se a validação for bem-sucedida
            this.processando(true);                                                                      // Indica que o processamento está em andamento
            this.loginUser();                                                                            // Realiza o login do usuário
            this.processando(false);                                                                     // Indica que o processamento foi concluído
          }
        });
      //}
    },

    loginUser() {                                                                                        // Método para realizar o login do usuário
      /*desabilitado (if (this.apresentacao) {                                                                           // Verifica se está em modo de apresentação
        this.showCaptcha = true;                                                                         // Exibe o modal do reCAPTCHA
        if (this.recaptchaVerified) {                                                                    // Verifica se o reCAPTCHA foi verificado
          LoginService.login(this.login, this.idCliente).then(                                           // Chama o serviço de login, passando as informações de login e o ID do cliente
            (data) => {
              //You can get warning (error: 'data' is defined but never used;), if you don't use parameters;
              console.log(data); // Exibe os dados retornados (para fins de depuração)
              if (LoginService.currentUserValue && LoginService.currentUserValue.homePage) {             // Verifica se o usuário atual possui uma página inicial definid
                const homePage = LoginService.currentUserValue.homePage;             
                this.$router.push(homePage);                                                             // Redireciona para a página inicial do usuário
              } else {             
                this.erro = "Login ou Senha inválidos!";                                                 // Define uma mensagem de erro caso o login ou a senha estejam inválidos
              }
            },
            (error) => {                                                                                 // Exibe o erro retornado (para fins de depuração)
              console.log(error);
              this.erro = "Login ou Senha inválidos!";                                                   // Define uma mensagem de erro caso ocorra um erro durante o login
            }
          );
        }
      } else {*/
        LoginService.login(this.login, this.idCliente).then(                                             // Chama o serviço de login, passando as informações de login e o ID do cliente
          (data) => {
            //You can get warning (error: 'data' is defined but never used;), if you don't use parameters;
            if (LoginService.currentUserValue && LoginService.currentUserValue.homePage) {               // Verifica se o usuário atual possui uma página inicial definida
              console.log(data);                                                                         // Exibe os dados retornados (para fins de depuração)
              const homePage = LoginService.currentUserValue.homePage;
              localStorage.setItem('displayInformacao', null);
              this.$router.push(homePage);                                                               // Redireciona para a página inicial do usuário
            } else {
              this.erro = "Login ou Senha inválidos!";                                                   // Define uma mensagem de erro caso o login ou a senha estejam inválidos
            }
          },
          (error) => {                                                                                   // Exibe o erro retornado (para fins de depuração)
            console.log(error);
            this.erro = "Login ou Senha inválidos!";                                                     // Define uma mensagem de erro caso ocorra um erro durante o login
          }
        );
      //}
    },

    
    processando(show) {                                                                                  // Método para mostrar/esconder loading
      if (show) {                                                              
        this.loading = true;                                                                             // Ativa o estado de loading
        this.$root.$emit("loading:show");                                                                // Emite um evento para mostrar o loading globalmente
      } else {                                                               
        this.loading = false;                                                                            // Desativa o estado de loading
        this.$root.$emit("loading:hide");                                                                // Emite um evento para esconder o loading globalmente
      }
    },

    esqueceuSenha() {                                                                                    // Métodos relacionados à recuperação de senha
      this.limparDadosPessoa();                                                                          // Limpa os dados da pessoa antes de mostrar a tela de recuperação                 
      this.showEsqueceu = true;                                                                          // Exibe a janela de recuperação de senha          
    },       

    hideNovaSenha() {                                                                                         
      this.loading = false;                                                                              // Desativa o loading ao fechar a janela
      this.showEsqueceu = false;                                                                         // Esconde a janela de recuperação de senha                                                                                     
    }, 

    limparDadosPessoa() {                                                                                         
      this.loginNovaSenha = null;                                                                        // Limpa o campo de nova senha                 
    },      

    requisitarNovaSenha() {                                                                     
      if (!this.loginNovaSenha) {                                                                        // Verifica se o campo de nova senha está vazio
        this.$root.$emit("alert:warn", "Informe um Login válido!");                                      // Emite um alerta de aviso                                
      } else {                                                                      
        this.loading = true;                                                                             // Ativa o loading ao iniciar a requisição
        LoginService.recuperarSenha(this.loginNovaSenha, this.idCliente).then(                           // Chama o serviço para recuperação de senha                                             
          (response) => {                                                                                
            console.log(response);                                                                       // Exibe a resposta no console (para fins de depuração)
            this.$root.$emit(                                                                            // Emite um alerta de sucesso informando que o e-mail foi enviado
              "alert:success",                                                                      
              "Foi enviado um e-mail para recuperação de Senha da sua conta!"                                                                     
            );                                                                      
          },                                                                      
          (error) => {                                                                                   
            console.log(error);                                                                          // Exibe o erro no console (para fins de depuração)
            this.loading = false;                                                                        // Desativa o loading em caso de erro
            this.$root.$emit("alert:warn", error.response.data);                                         // Emite um alerta de aviso com a mensagem de erro                             
          }                                                                     
        );                                                                      
      }
    },

    formataValorReal(valor) {                             // Método para formatar valor em Real
      if (typeof valor !== 'number' || isNaN(valor)) {    // Verifica se o valor é válido e é um número
        return '';                                        // Retorna uma string vazia se o valor não for um número válido
      }
    
      const formatter = new Intl.NumberFormat('pt-BR', {  // Formatando o valor para moeda brasileira (BRL)
        style: 'currency',                                // Define o estilo como moeda
        currency: 'BRL'                                   // Define a moeda como Real brasileiro
      });                               
    
      return formatter.format(valor);                     // Retorna o valor formatado
    },

    // Métodos de ação para os botões
    autenticar() {
      this.$router.push("/autenticacao");
    },
    retencao() {
      this.$router.push("/reciboRetencao");
    },
    credenciar() {
      this.$router.push("/credenciamento");
    },
    abrirLinkRps() {
      this.showLinkRps = true;
    },
    contribuintes() {
      this.$router.push("/contribuintes");
    },
    consultarRps() {
      this.$router.push("/consultaRps");
    },
    denunciaFiscal() {
      this.$router.push("/denunciaFiscal");
    },
    dadosContato() {
      this.openDialogMsgContato = true;
    },
    copiarLinkRps() {
      navigator.clipboard.writeText(this.numbers.linkRps);
    },

    

    carregarLinks(){
      let retorno = [];
      retorno.push(
        {
          text: "Clique aqui para se Credenciar",
          icon: require("@/assets/icons/icon-credencial.svg"),
          alt: "Ícone credencial",
          action: this.credenciar,
          route: "/credenciamento"
        }
      );
      retorno.push(
        {
          text: "Clique aqui para autenticar Documento",
          icon: require("@/assets/icons/icon-doc.svg"),
          alt: "Ícone autenticar documento",
          action: this.autenticar,  // Ação ao clicar no botão
          route: "/autenticacao"  // Rota para onde o botão leva
        }
      );
      retorno.push(
        {
          text: "Clique aqui para Recibo de Retenção",
          icon: require("@/assets/icons/icon-recibo.svg"),
          alt: "Ícone recibo de retenção",
          action: this.retencao,
          route: "/reciboRetencao"
        }
      );
      if(this.numbers && this.numbers.linkRps){
        retorno.push(
          {
            text: "Link Envio RPS",
            icon: require("@/assets/icons/icon-link.svg"),
            alt: "Ícone link envio RPS",
            action: this.abrirLinkRps,
            route: null
          }
        );
      }
      retorno.push(
        {
          text: "Clique para consultar RPS convertido em NFS-e.",
          icon: require("@/assets/icons/icon-consultar.svg"),
          alt: "Ícone consultar",
          action: this.consultarRps,
          route: "/consultaRps"
        }
      );
      if(!this.manutencao && this.numbers && this.numbers.linkTutoriais){
        retorno.push(
          {
            text: "Acesso aos tutoriais",
            icon: require("@/assets/icons/icon-consultar.svg"),
            alt: "Ícone Tutoriais",
            // Abre o link dos tutoriais em nova aba
            action: () => {
              window.open(this.numbers.linkTutoriais, '_blank'); // Abre o link dos tutoriais em nova aba
            },
            route: null
          }
        );
      }
      if(this.apresentacao){
        retorno.push(
          {
            text: "Listagem de Contribuintes",
            icon: require("@/assets/icons/icon-listagem.svg"),
            alt: "Ícone listagem",
            action: this.contribuintes,
            route: "/contribuintes"
          }
        );
      }
      if(this.showDenunciaFiscal){
        retorno.push(
          {
            text: "Realize uma Denúncia relacionada à Prestação de Serviços.",
            icon: require("@/assets/icons/icon-denuncia.svg"),
            alt: "Ícone denuncia",
            action: this.denunciaFiscal,
            route: "/denunciaFiscal"
          }
        );
      }
      return retorno;
    },

    hideJanelaSenha() {                                  // Método para esconder a janela de senha
      this.showEsqueceu = false;                        // Define a variável que controla a exibição da janela de senha como falsa                                              
      this.loading = false;                             // Esconde o indicador de loading
    },

  },

  computed: {
    mensagemErro() {                                                                                                  // Propriedade computada para gerar mensagens de erro baseadas no código de erro recebido na rota
      let codigoErro = this.$route.query.erro;                                                                        // Obtém o código de erro da query da rota atual
      let msg = '';                                                                   
      if (codigoErro) {                                                                                               // Verifica se um código de erro foi fornecido
        switch (codigoErro) {                                                                                         // Define a mensagem de erro com base no código de erro
          case '1':
            msg = 'Autenticador Certisign não disponivel para realizar o Login.';                                     // Mensagem para erro 1
            break;                                    
          case '2':                                   
            msg = 'Não foi possível validar o certificado digital.';                                                  // Mensagem para erro 2
            break;                                    
          case '3':                                   
            msg = 'Chave de criptografia do certificado inválida.';                                                   // Mensagem para erro 3
            break;                                    
          case '4':                                   
            msg = 'Período de validade do certificado digital expirado.';                                             // Mensagem para erro 4
            break;                                    
          case '5':                                   
            msg = 'Não foi posssível obter a data de validade do certificado.';                                       // Mensagem para erro 5
            break;
          case '6':
            msg = 'Usuário não encontrado com documento relacionado ao certificado.';                                 // Mensagem para erro 6
            break;
          case '7':
            msg = 'Não foi possível validar o certificado digital.';                                                  // Mensagem para erro 7
            break;
        }
        return msg;                                                                                                   // Retorna a mensagem de erro correspondente
      } else {                                                                                                  
        return null;                                                                                                  // Se não houver código de erro, retorna null
      }
    },
  }
};
</script>

<style src="@/assets/css/login.css"></style>